import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/mamamyanmar/footer';
import Header from '../components/mamamyanmar/header';
import HomePage from '../pages/mamamyanmar/home_page';
import ContactPage from '../pages/mamamyanmar/contact_page';

export default function MamaMyanmarTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
            />
            <Footer />
        </React.Fragment>
    )
}
